// Solo letras (con acentos/ñ), espacios, apóstrofes y guiones — sin números ni símbolos
export const NAME_PATTERN = /^[A-Za-zÀ-ÿÑñ\s'-]*$/;

// Normaliza un texto para comparaciones case/acento-insensibles (detección de duplicados)
export function normalizeForComparison(value: string): string {
  return value.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
}
